import {
  PublishingSplitData,
  RecordingSplitData,
  hasSplitFieldValue,
} from '@disco/state-management/reducers/rightsManagement'

function determineErorMessage(isBulkMode, totalSplitPercentage) {
  return isBulkMode
    ? `Sum of splits percentages exceeds 100%. Currently ${totalSplitPercentage}%. Cannot add splits that exceed 100% total.`
    : totalSplitPercentage > 100
    ? `Sum of splits percentages exceeds 100%. Currently ${totalSplitPercentage}%`
    : `Sum of splits percentages do not equal 100%. Currently ${totalSplitPercentage}%`
}

export function checkRecordingSplits(
  splits: RecordingSplitData[],
  { isBulkMode, splitsValidation, totalSplitPercentage },
): string | null {
  const hasOnlyEmptyPlaceholders = splits.every(split => {
    const hasRightsholder = hasSplitFieldValue(split.rightsholderId)
    const hasLabel = hasSplitFieldValue(split.labelId)
    const hasSplit = hasSplitFieldValue(split.split)
    return !hasRightsholder && !hasLabel && !hasSplit
  })

  const showSplitsWarning = hasOnlyEmptyPlaceholders
    ? false
    : isBulkMode
    ? splitsValidation.errors.recSplitsTotalAbove100
    : splitsValidation.errors.recSplitsTotalAbove100 ||
      totalSplitPercentage !== 100

  if (showSplitsWarning) {
    return determineErorMessage(isBulkMode, totalSplitPercentage)
  }

  return null
}

export function checkPublishingSplits(
  splits: PublishingSplitData[],
  { isBulkMode, splitsValidation, totalSplitPercentage },
) {
  const hasOnlyEmptyPlaceholders = splits.every(split => {
    const hasWriter = typeof split.writerId === 'number' && split.writerId > 0
    const hasPublisher =
      typeof split.publisherId === 'number' && split.publisherId > 0
    const hasPro = typeof split.proId === 'number' && split.proId > 0
    const hasSplit = split.split != null
    return !hasWriter && !hasPublisher && !hasPro && !hasSplit
  })

  const showSplitsWarning = hasOnlyEmptyPlaceholders
    ? false
    : isBulkMode
    ? splitsValidation.errors.splitsTotalAbove100
    : splitsValidation.errors.splitsTotalAbove100 ||
      totalSplitPercentage !== 100

  if (showSplitsWarning) {
    return determineErorMessage(isBulkMode, totalSplitPercentage)
  }

  return null
}
